
export default function ClientsSection() {
  const clients = [
    { 
      name: 'Autoblock', 
      url: 'https://www.autoblocks.ai/',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/2f872dacf661b7b464160acc2213133c.jfif'
    },
    { 
      name: 'Conversions', 
      url: 'https://conversion.ai',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/f202f4a743aeaf78f5dd76f7cc9faccf.png'
    },
    { 
      name: 'Otter.ai', 
      url: 'https://otter.ai',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/ff5ddbbbd1cce625aebe701b649632bc.png'
    },
    { 
      name: 'HeyGen', 
      url: 'https://www.heygen.com',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/e005f98e4b0bccce59be457f973016bf.png'
    },
    { 
      name: 'Gamma', 
      url: 'https://gamma.app',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/8c4fbd976b7853d06242fd4d87d512f0.png'
    },
    { 
      name: 'Cartesia', 
      url: 'https://cartesia.ai',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/47ca17e412ab5819cdaa9cbb09081ed1.png'
    },
    { 
      name: 'Zeemo', 
      url: 'https://zeemo.ai',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/15efae4d4f23ceaf0d3ff2d322af3a09.png'
    },
    { 
      name: 'Microsoft', 
      url: 'https://www.microsoft.com',
      image: 'https://public.readdy.ai/ai/img_res/5b0711df757f96fc46e45385983608de.jpg'
    },
    { 
      name: 'XMind.ai', 
      url: 'https://xmind.ai',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/15efae4d4f23ceaf0d3ff2d322af3a09.png'
    },
    { 
      name: 'LiveX.ai', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=LiveX%20AI%20live%20streaming%20technology%20logo%2C%20artificial%20intelligence%20broadcasting%20platform%20branding%2C%20modern%20live%20video%20technology%20company%20logo%2C%20professional%20streaming%20software%20branding&width=200&height=200&seq=livex-logo&orientation=squarish'
    },
    { 
      name: 'Bardeen', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=Bardeen%20automation%20software%20logo%2C%20workflow%20automation%20platform%20branding%2C%20modern%20productivity%20tool%20logo%2C%20professional%20business%20automation%20software%20branding%2C%20contemporary%20workflow%20technology%20logo&width=200&height=200&seq=bardeen-logo&orientation=squarish'
    },
    { 
      name: 'Wegic.ai', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=Wegic%20AI%20website%20builder%20logo%2C%20artificial%20intelligence%20web%20development%20platform%20branding%2C%20modern%20AI%20website%20creation%20tool%20logo%2C%20professional%20web%20design%20software%20branding&width=200&height=200&seq=wegic-logo&orientation=squarish'
    },
    { 
      name: 'AddEvent', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=AddEvent%20calendar%20management%20software%20logo%2C%20event%20scheduling%20platform%20branding%2C%20modern%20calendar%20technology%20company%20logo%2C%20professional%20event%20management%20software%20branding&width=200&height=200&seq=addevent-logo&orientation=squarish'
    },
    { 
      name: 'First Round', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=First%20Round%20venture%20capital%20firm%20logo%2C%20professional%20investment%20company%20branding%2C%20modern%20VC%20fund%20logo%20design%2C%20contemporary%20venture%20capital%20branding%2C%20startup%20investment%20firm%20logo&width=200&height=200&seq=firstround-logo&orientation=squarish'
    },
    { 
      name: 'Jobright.ai', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=Jobright%20AI%20recruitment%20platform%20logo%2C%20artificial%20intelligence%20job%20matching%20software%20branding%2C%20modern%20HR%20technology%20company%20logo%2C%20professional%20recruitment%20software%20branding&width=200&height=200&seq=jobright-logo&orientation=squarish'
    },
    { 
      name: 'Lanhu Design', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=Lanhu%20Design%20collaboration%20platform%20logo%2C%20design%20software%20company%20branding%2C%20modern%20design%20tool%20logo%2C%20professional%20creative%20software%20branding%2C%20contemporary%20design%20platform%20logo&width=200&height=200&seq=lanhu-logo&orientation=squarish'
    },
    { 
      name: 'Linkloud', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=Linkloud%20cloud%20storage%20platform%20logo%2C%20modern%20cloud%20technology%20company%20branding%2C%20professional%20data%20storage%20software%20logo%2C%20contemporary%20cloud%20computing%20platform%20branding&width=200&height=200&seq=linkloud-logo&orientation=squarish'
    },
    { 
      name: 'MileIQ', 
      url: '#',
      image: 'https://readdy.ai/api/search-image?query=MileIQ%20mileage%20tracking%20app%20logo%2C%20professional%20business%20expense%20software%20branding%2C%20modern%20mobile%20app%20logo%20design%2C%20contemporary%20business%20productivity%20tool%20branding&width=200&height=200&seq=mileiq-logo&orientation=squarish'
    }
  ];

  return (
    <section id="clients" className="py-20 bg-gradient-to-br from-gray-50 via-amber-50/20 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Clients</span> & <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Customers</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-600 mx-auto mb-8 shadow-sm"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trusted by <span className="text-amber-700 font-semibold">leading companies</span> and <span className="text-amber-700 font-semibold">innovative startups</span> worldwide
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-16">
          {clients.map((client, index) => (
            <a 
              key={index} 
              href={client.url}
              target={client.url !== '#' ? '_blank' : '_self'}
              rel={client.url !== '#' ? 'noopener noreferrer' : undefined}
              className="group bg-gradient-to-br from-white via-amber-50/30 to-white rounded-lg p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105 flex flex-col items-center justify-center text-center min-h-[140px] border border-amber-100/30 hover:border-amber-200/50 cursor-pointer"
            >
              <div className="relative mb-4">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-200/20 to-yellow-200/20 rounded-lg transform scale-110"></div>
                <img 
                  src={client.image}
                  alt={`${client.name} logo`}
                  className="relative w-16 h-16 object-contain rounded-lg shadow-sm"
                />
              </div>
              <p className="font-semibold text-gray-900 text-sm group-hover:text-amber-800 transition-colors">
                {client.name === 'Microsoft' ? (
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">Microsoft</span>
                ) : client.name.includes('.ai') ? (
                  <>
                    {client.name.replace('.ai', '')}<span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">.ai</span>
                  </>
                ) : (
                  client.name
                )}
              </p>
            </a>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl p-6 shadow-lg border border-amber-100/30 hover:shadow-xl transition-all duration-300">
            <div className="relative mb-4">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-200/40 to-yellow-200/40 rounded-full transform scale-110"></div>
              <div className="relative w-16 h-16 bg-gradient-to-r from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-trophy-line text-white text-2xl"></i>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 mb-2">50+</h3>
            <p className="text-gray-600">
              Successful <span className="text-amber-700 font-medium">Premium</span> Campaigns
            </p>
          </div>

          <div className="text-center bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl p-6 shadow-lg border border-amber-100/30 hover:shadow-xl transition-all duration-300">
            <div className="relative mb-4">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-200/40 to-yellow-200/40 rounded-full transform scale-110"></div>
              <div className="relative w-16 h-16 bg-gradient-to-r from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 mb-2">18+</h3>
            <p className="text-gray-600">
              <span className="text-amber-700 font-medium">Elite</span> Happy Clients
            </p>
          </div>

          <div className="text-center bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl p-6 shadow-lg border border-amber-100/30 hover:shadow-xl transition-all duration-300">
            <div className="relative mb-4">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-200/40 to-yellow-200/40 rounded-full transform scale-110"></div>
              <div className="relative w-16 h-16 bg-gradient-to-r from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-line-chart-line text-white text-2xl"></i>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 mb-2">300%</h3>
            <p className="text-gray-600">
              Average <span className="text-amber-700 font-medium">Excellence</span> Growth Rate
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
